import apiClient from "../../../utilities/apiClient";

export const getBusinessUnitLists = (page, per_page, search) => {
  return apiClient.get(
    `${
      apiClient.Urls.business_unit_list
    }?page=${page}&per_page=${per_page}&search=${search || ""}`,
    "",
    true,
  );
};

export const createBusinessUnit = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.create_business_unit}`,
    payload,
    true,
  );
};

export const deleteBusinessUnit = (payload) => {
  return apiClient.delete(
    `${apiClient.Urls.delete_business_unit}/${payload?.id}`,
    {},
    true,
  );
};

export const updateBusinessUnitStatus = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.update_business_unit_status}/${payload?.id}`,
    { isActive: payload?.isActive },
    true,
  );
};

export const assignCompanyToBusinessUnit = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.business_unit_assign_company_user}`,
    payload,
    true,
  );
};

export const getAssignCompanyList = () => {
  return apiClient.get(
    `${apiClient.Urls.business_unit_assign_company}`,
    {},
    true,
  );
};

export const getAssignUserList = () => {
  return apiClient.get(`${apiClient.Urls.business_unit_assign_user}`, {}, true);
};

export const getBusinessUnitById = (id) => {
  return apiClient.get(
    `${apiClient.Urls.get_business_unit_by_id}/${id}`,
    {},
    true,
  );
};

export const getBusinessUnitUsers = (companyId, businessUnitId) => {
  return apiClient.get(
    `${apiClient.Urls.get_business_unit_users}/${companyId}/${businessUnitId}`,
    {},
    true,
  );
};
